export default __webpack_public_path__ + "static/star_stake-11b7e5b29f1886a5e67bc3306d2bdf74.mp4";